// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"mode-view_textBlock__G_luc","oFormTitle":"mode-view_oFormTitle__b83at"};